/**
* DevExpress Analytics (property-grid\localization\localization_utils.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _utils_1 = require("../../serializer/_utils");
var _localization_1 = require("./_localization");
function addCultureInfo(json) {
    _utils_1.extend(_localization_1.messages, json.messages);
}
exports.addCultureInfo = addCultureInfo;
function getLocalization(text, id, _removeWinSymblols) {
    return _localization_1.getLocalization(text, id, _localization_1.removeWinSymbols);
}
exports.getLocalization = getLocalization;
function _stringEndsWith(string, searchString) {
    return string.indexOf(searchString, this.length - searchString.length) !== -1;
}
exports._stringEndsWith = _stringEndsWith;
function updateLocalization(object) {
    _utils_1.extend(_localization_1.custom_localization_values, object);
    var messages = {};
    Object.keys(object).forEach(function (name) {
        messages[name] = object[name];
    });
    addCultureInfo({
        messages: messages
    });
}
exports.updateLocalization = updateLocalization;
